import type { UUID } from "../../../../utils/uuid";

type UsesRestrictedDataParams = {
  restrictedSegments: UUID[];
  restrictedEmails: UUID[];
  customEmailAddresses?: { id: UUID; address: string }[];
  email_from_address: string | null;
  segment_id: UUID | null;
};

export function usesRestrictedSegmentOrEmail({
  restrictedSegments,
  restrictedEmails,
  email_from_address,
  segment_id,
  customEmailAddresses,
}: UsesRestrictedDataParams): boolean {
  const usesRestrictedSegment = segment_id && restrictedSegments.includes(segment_id);

  const selectedEmailFromId = customEmailAddresses?.find(
    (e) => e.address === email_from_address,
  )?.id;

  const usesRestrictedEmailFrom =
    selectedEmailFromId && restrictedEmails.includes(selectedEmailFromId);

  return Boolean(usesRestrictedSegment || usesRestrictedEmailFrom);
}
